var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MIcon',{staticClass:"mx-1",attrs:{"name":(_vm.iconMap[_vm.moduleName] || {}).name || 'tire-rugged',"size":"2x"}})
}
var staticRenderFns = []

export { render, staticRenderFns }